import { Pipe, PipeTransform, inject } from '@angular/core';
import { StockService } from './stock.service';
import { StockInfo, StockMap } from '@pedix-workspace/shared-stock';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { toObservable } from '@angular/core/rxjs-interop';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Pipe({
  name: 'pxwStockInfo',
  standalone: true,
})
export class StockInfoPipe implements PipeTransform {
  private stockService = inject(StockService);

  stock$: Observable<StockMap>;

  constructor() {
    this.stock$ = toObservable(this.stockService.stock);
  }

  transform(cartItemId: string): Observable<StockInfo> {
    return this.stock$.pipe(
      untilDestroyed(this),
      map(stock => stock.getStockInfoByItem(cartItemId)),
    );
  }
}
